//@ts-check
/**
 * Aggregate OPFS cache counters shared by {@link RcsOpfsCacheClient} and
 * {@link RcsWorkerPool}. Kept in a separate module because those two import
 * each other and both need to increment these fields.
 */
export class RcsOpfsCacheStats {
  /** OPFS geometry cache hits (inner nodes, leaf LODs, and LOD-0; includes {@link lod0CacheHits}). */
  static cacheHits = 0;
  /** OPFS cache misses since last reset. */
  static cacheMisses = 0;
  /** Bytes read from OPFS on cache hits since last reset. */
  static cacheBytesLoaded = 0;
  /** SVO payload bytes fetched from the network since last reset. */
  static networkBytesLoaded = 0;
  /** Raw LOD-0 SVO byte cache hits (also counted in {@link cacheHits}). */
  static lod0CacheHits = 0;
  /** Raw LOD-0 SVO byte cache misses since last reset. */
  static lod0CacheMisses = 0;

  /** Zero every counter, so a measurement can cover one load in isolation. */
  static reset() {
    RcsOpfsCacheStats.cacheHits = 0;
    RcsOpfsCacheStats.cacheMisses = 0;
    RcsOpfsCacheStats.cacheBytesLoaded = 0;
    RcsOpfsCacheStats.networkBytesLoaded = 0;
    RcsOpfsCacheStats.lod0CacheHits = 0;
    RcsOpfsCacheStats.lod0CacheMisses = 0;
  }
}